import { DialogService } from 'primeng/dynamicdialog';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable()
export class ToastService {
  constructor(
    public messageService: MessageService,
    public dialogService: DialogService
  ) {}

  showSuccess(details: string, displayFor: number = 5000) {
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: details,
      life: displayFor,
    });
  }

  showInfo(details: string, displayFor: number = 5000) {
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: details,
      life: displayFor,
    });
  }

  showWarn(details: string, displayFor: number = 5000) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: details,
      life: displayFor,
    });
  }

  showError(details: string, displayFor: number = 5000) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: details,
      life: displayFor,
    });
  }

}
